import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import tracking from 'dibs-tracking';
import { getUserSessionCountryCode } from 'dibs-buyer-layout/exports/regionalInfoHelpers';

import { LABEL_CONTACT_LINK } from '../authentication/authConstants';
import { CONTACT_DEALER_FLOW, sharedLoginCheck } from '../authentication/sharedLoginCheck';
import contactDealerLauncher from 'dibs-buyer-layout/exports/contactDealerLauncher';
import { TradeMultiRequestModalLoader } from 'dibs-buyer-layout/exports/TradeMultiRequestModalLoader';
import { getQueryParam } from '../utils/uriUtils';

class SharedContactDealerWrapperComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { shouldLoad: false, isOpen: false };
        this.showMultiRequestModal = this.getShowMultiRequestModal(props);
        this.onModalClose = this.onModalClose.bind(this);
        this.doRefetch = this.doRefetch.bind(this);
        this.onContactClick = this.onContactClick.bind(this);
        this.launchAuthModal = this.launchAuthModal.bind(this);
    }

    componentDidMount() {
        const queryParams = get(global, 'location.search');
        const modalParam = getQueryParam(queryParams, 'modal');
        if (
            this.props.loadOnMount ||
            (this.props.modalType === 'CONTACT_DEALER' && modalParam === 'contact-dealer')
        ) {
            this.onContactClick();
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.user && nextProps.user) {
            this.showMultiRequestModal = this.getShowMultiRequestModal(nextProps);
        }
    }
    loadModal() {
        if (this.showMultiRequestModal) {
            this.setState({ shouldLoad: true, isOpen: true });
        }
    }
    doRefetch(refetchVariables) {
        const variables = { ...refetchVariables, userCountryCode: getUserSessionCountryCode() };
        this.props.relay.refetch(variables);
    }
    onModalClose() {
        if (this.showMultiRequestModal) {
            this.setState({ isOpen: false });
        }
    }
    onContactClick() {
        if (this.showMultiRequestModal) {
            this.loadModal();
        } else {
            const { relay, item, launchOrigin, modalType, user, currency } = this.props;
            tracking.trackEvent({
                category: 'contact dealer',
                action: 'contact dealer clicked',
                label: launchOrigin,
            });
            contactDealerLauncher({
                environment: relay.environment,
                itemId: item.serviceId,
                launchOrigin,
                modalType,
                currency: currency,
                userId: (user && user.serviceId) || null,
                onSuccessfulShippingQuoteRequest: this.doRefetch,
            });
        }
    }
    launchAuthModal({ email, linkLocation: launchSource }) {
        sharedLoginCheck({
            authOptions: {
                email,
                flow: CONTACT_DEALER_FLOW,
                ga: { label: `${LABEL_CONTACT_LINK} - ${launchSource}` },
            },
        });
    }
    getShowMultiRequestModal(props) {
        return (
            (props.modalType === 'CONTACT_DEALER' || props.modalType === 'REQUEST_CUSTOMIZATION') &&
            props.user &&
            !!props.user.isVerifiedTrade
        );
    }

    render() {
        const {
            children,
            item,
            message,
            name,
            launchOrigin,
            user,
            modalType,
            modalContentData,
        } = this.props;

        const { shouldLoad, isOpen } = this.state;
        return (
            <React.Fragment>
                <div data-tn="contact-dealer-wrapper-cta" onClick={this.onContactClick}>
                    {children}
                </div>
                {this.showMultiRequestModal && (
                    <TradeMultiRequestModalLoader
                        load={shouldLoad}
                        itemId={item.serviceId}
                        launchAuth={this.launchAuthModal}
                        linkLocation={launchOrigin}
                        message={message}
                        name={name}
                        isOpen={isOpen}
                        onClose={this.onModalClose}
                        sellerId={item.seller.serviceId}
                        userId={user && user.serviceId}
                        modalType={modalType}
                        modalContentData={modalContentData}
                        onSuccessfulShippingQuoteRequest={this.doRefetch}
                    />
                )}
            </React.Fragment>
        );
    }
}

SharedContactDealerWrapperComponent.propTypes = {
    children: PropTypes.node,
    item: PropTypes.object.isRequired,
    launchOrigin: PropTypes.string.isRequired,
    loadOnMount: PropTypes.bool,
    message: PropTypes.string,
    modalContentData: PropTypes.object,
    modalType: PropTypes.oneOf([
        'CONTACT_DEALER',
        'REQUEST_CUSTOMIZATION',
        'REQUEST_PRICE',
        'REQUEST_IMAGES',
    ]),
    name: PropTypes.string,
    relay: PropTypes.object.isRequired,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
};

SharedContactDealerWrapperComponent.defaultProps = {
    loadOnMount: false,
    modalType: 'CONTACT_DEALER',
};

SharedContactDealerWrapperComponent = SharedContactDealerWrapperComponent;

export const SharedContactDealerWrapper = createRefetchContainer(
    SharedContactDealerWrapperComponent,
    {
        item: graphql`
            fragment SharedContactDealerWrapper_item on Item {
                seller {
                    serviceId
                }
                serviceId
            }
        `,
        user: graphql`
            fragment SharedContactDealerWrapper_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
    },
    graphql`
        query SharedContactDealerWrapperRefetchQuery(
            $userId: String!
            $fetchUser: Boolean!
            $itemId: String!
            $userZipCode: String = "0"
            $userCountryCode: String = ""
            $fetchRegionalInfo: Boolean = false
        ) {
            viewer {
                ...PdpSharedShippingInfoLink_viewer
                ...PdpSharedBlurbShipping_viewer
                relevantShipping(itemId: $itemId, buyerId: $userId) {
                    quoteRequestStatus
                    shipmentQuote {
                        ...PdpSharedBlurbShipping_shipmentQuote
                    }
                    shipment {
                        ...PdpSharedBlurbShipping_shipment
                    }
                }
            }
        }
    `
);
